export const filenameHasExtension = (
  filename: string,
  ext: string,
): boolean => {
  return filename.toLowerCase().endsWith(ext.toLowerCase());
};

export const getDownloadFilenameForDocument = (
  filename: string,
  extension?: string | null,
): string => {
  if (!extension) {
    return filename;
  }

  if (filenameHasExtension(filename, extension)) {
    return filename;
  }

  return `${filename}${extension}`;
};
